import { atom } from 'jotai';

export enum PushSectionsToEhrState {
  IDLE = 'idle',
  CONFIRM = 'confirm',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export const sectionalWritebackInformModalOpenAtom = atom<{
  open: boolean;
  from: 'template_editor' | 'push_note_to_ehr' | undefined;
}>({
  open: false,
  from: undefined,
});

// push to Ehr button state
export const sectionalWritebackPushToEhrStateAtom = atom<PushSectionsToEhrState>(
  PushSectionsToEhrState.IDLE
);
